import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import React from "react";
import { useLazyLoadQuery, graphql, useMutation } from "react-relay";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { EmployeeScheduleEditScheduleList } from "./EmployeeScheduleEditScheduleList";
import { EmployeeScheduleStackParamList } from "./EmployeeScheduleEditStack";
import { EmployeeScheduleEditScheduleTypesScreenQuery } from "./__generated__/EmployeeScheduleEditScheduleTypesScreenQuery.graphql";
import { useIntl } from "react-intl";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useAlert } from "@/src/common/Alert";
import { EmployeeScheduleEditScheduleTypesScreenDeactivateMutation } from "./__generated__/EmployeeScheduleEditScheduleTypesScreenDeactivateMutation.graphql";
import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";

export function EmployeeScheduleEditScheduleTypesScreen(props: {
  navigation: NativeStackNavigationProp<
    EmployeeScheduleStackParamList,
    "EmployeeScheduleEditScheduleTypes"
  >;
}) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => (
        <InnerEmployeeScheduleEditScheduleTypesScreen
          {...props}
          fetchKey={fetchKey}
        />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerEmployeeScheduleEditScheduleTypesScreen(props: {
  fetchKey: string;
  navigation: NativeStackNavigationProp<
    EmployeeScheduleStackParamList,
    "EmployeeScheduleEditScheduleTypes"
  >;
}) {
  const data = useLazyLoadQuery<EmployeeScheduleEditScheduleTypesScreenQuery>(
    graphql`
      query EmployeeScheduleEditScheduleTypesScreenQuery {
        store {
          ...EmployeeScheduleEditScheduleList_store
        }
      }
    `,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  const [deactivate,] =
    useMutation<EmployeeScheduleEditScheduleTypesScreenDeactivateMutation>(
      graphql`
        mutation EmployeeScheduleEditScheduleTypesScreenDeactivateMutation {
          store {
            deactivateIntegrationEmployeeProvider
          }
        }
      `
    );

  const { alert } = useAlert();
  const intl_tokens = useIntlTokens();

  const intl = useIntl();
  const title = intl.formatMessage({
    defaultMessage: "Deactivate Integration",
    description: "Deactivate Employee Schedule Integration Button Label",
  });
  const confirmationMessage = intl.formatMessage({
    defaultMessage: "Are you sure you want to deactivate the integration?",
    description:
      "Deactivate Employee Schedule Integration Confirmation Message",
  });

  function onPress() {
    alert(title, confirmationMessage, [
      {
        style: "cancel",
        text: intl_tokens.Cancel,
      },
      {
        style: "destructive",
        text: intl_tokens.Delete,
        onPress: () => {
          deactivate({
            variables: {},
            onCompleted: () => {
              props.navigation.goBack();
            },
          });
        },
      },
    ]);
  }

  useNavigationHeader({
    type: "CLOSE",
    onClose: () => {
      props.navigation.goBack();
    },
    headerTitle: intl.formatMessage({
      defaultMessage: "Assign Cost Centers",
      description: "Title for EmployeeScheduleEditScheduleTypesScreen", // "Tilldela Kostnadsställen"
    }),
    defaultContentStyle: true,
    more: [
      {
        label: title,
        onPress: onPress,
        icon: "trash",
        color: "negative",
        type: "button",
      },
    ],
  });

  return (
    <EmployeeScheduleEditScheduleList
      onPress={(teamId, teamName) => {
        props.navigation.navigateDeprecated(
          "EmployeeScheduleEditScheduleTypesAssignTeam",
          {
            teamId,
            teamName,
          }
        );
      }}
      store={data.store}
    />
  );
}
